/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  PrivacyRightsMainComponentProps,
  PhoenixLegalPrivacyConsentResponseResult,
} from '../PrivacyRightsWrapper.types';

import { DONOT_SELL_SHARE_SECTION_CODE } from '../../../molecules/PrivacyRightsComponent/constant';

const getUniqueId = () => {
  return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID().slice(0, 8)
    : Math.random().toString(36).substring(2, 10);
};

export const transFormPrivacyRightsWrapperAEMSchemaToPrivacyRightsMainComponentProps = (
  privacyRightsAemModelData: PrivacyRightsMainComponentProps
): PrivacyRightsMainComponentProps => {
  const transformedSchema = {
    ...privacyRightsAemModelData,
    statesData: privacyRightsAemModelData.statesData.map(stateData => ({
      ...stateData,
      uniqueId: getUniqueId(),
      stateUnAuthContent: {
        ...stateData.stateUnAuthContent,
        doNotSellShareSections: stateData.stateUnAuthContent.doNotSellShareSections?.map(doNotSellShareSection => ({
          ...doNotSellShareSection,
          uniqueId: getUniqueId(),
          privacyListItems: doNotSellShareSection.privacyListItems?.map(privacyListItem => ({
            ...privacyListItem,
            isDoNotSellSection: doNotSellShareSection.isDoNotSellSection,
            uniqueId: getUniqueId(),
          })),
        })),
      },
      stateAuthContent: {
        ...stateData.stateAuthContent,
        doNotSellShareSections: stateData.stateAuthContent.doNotSellShareSections?.map(doNotSellShareSection => ({
          ...doNotSellShareSection,
          uniqueId: getUniqueId(),
          privacyListItems: doNotSellShareSection.privacyListItems?.map(privacyListItem => ({
            ...privacyListItem,
            isDoNotSellSection: doNotSellShareSection.isDoNotSellSection,
            uniqueId: getUniqueId(),
          })),
        })),
      },
    })),
  };

  return transformedSchema;
};

export const transformCustomerData = (response: PhoenixLegalPrivacyConsentResponseResult) => {
  const customer = response?.customer;
  if (!customer) {
    return null;
  }

  const { givenName, fullName } = customer.profile.name;
  const privacyConsentFeatures = customer.featuresByGroup.privacyConsentFeatures;
  const addresses = customer.contactInformation.addresses;

  const { DONOT_SELL_FETCH_SECTION_CODE, DONOT_SHARE_FETCH_SECTION_CODE, DONOT_SELL_SHARE_OPTIN_VALUE } =
    DONOT_SELL_SHARE_SECTION_CODE;

  const doNotSellOptIn = privacyConsentFeatures.some(
    feature => feature.feature.code === DONOT_SELL_FETCH_SECTION_CODE && feature.value === DONOT_SELL_SHARE_OPTIN_VALUE
  );

  const doNotShareOptIn = privacyConsentFeatures.some(
    feature => feature.feature.code === DONOT_SHARE_FETCH_SECTION_CODE && feature.value === DONOT_SELL_SHARE_OPTIN_VALUE
  );

  const primaryAddress = addresses.length > 0 ? addresses[0].address : null;
  const stateCode = primaryAddress?.stateProvince ?? null;
  const countryCode = primaryAddress?.country?.code ?? null;

  return {
    name: givenName || fullName,
    stateCode,
    countryCode,
    doNotSellOptIn,
    doNotShareOptIn,
  };
};

export const capitalizeFirstLetter = (inputWord: string) =>
  inputWord.charAt(0).toUpperCase() + inputWord.slice(1).toLowerCase();
